import { render, staticRenderFns } from "./PaginatedList.vue?vue&type=template&id=29dd5c2c"
import script from "./PaginatedList.vue?vue&type=script&lang=js"
export * from "./PaginatedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports